<template>
  <div class="bg-white h-auto p-6">
    <p
      class="font-sans text-grey-darker pb-6"
    >
      If your business hours go past 12:00AM, you need to add it separately.
      For Example: If your restaurant runs from 6:00PM - 2:00AM,
      you need to have one schedule for 6:00PM - 12:00AM and another one for 12:00AM - 02:00AM.
    </p>
    <div class="flex flex-col">
      <list-schedule />
      <pt-loader
        v-if="isLoading"
        icon-class="fa-refresh fa-5x text-white"
        container="body"
      />
    </div>

    <pt-button
      variant="primary"
      @action="editSchedule"
    >+ Edit Schedule</pt-button>

    <edit-schedule
      ref="collapsibleSidebarRight"
      :info="info"
      @closeAddEdit="closeAddEdit"
      @refreshList="fetchList"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import ListRow from './list-row';
import { PtList, PtListItem } from '@pathao/ui-components/esm/List';

import EditSchedule from './edit-schedule.vue';
import listSchedule from './list-schedule.vue';
export default {
  name: 'WorkingHours',
  components: {
    PtList,
    PtListItem,
    EditSchedule,
    listSchedule,
  },
  props: {
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      loadingError: false,
      loading: false,
      info: null,
      isEdit: false,
      isSuccess: true,
      messageText: 'Changes Saved',
      subtitleText: 'Your Business Hours have been set',
    };
  },
  computed: {
    ...mapGetters({
      list: 'schedules/scheduleList',
    }),
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    editSchedule() {
      this.$sendEvent('RS_EditSchedule');
      this.info = this.list;
      this.$refs.collapsibleSidebarRight.toggle();
    },
    closeAddEdit() {
      this.info = null;
    },
    showResponseModal() {
      this.$refs.responseModal.showModal();
    },
    async fetchList() {
      this.isLoading = true;
      try {
        await this.fetchScheduleList();
      } catch (error) {
        this.$notification.error('Failed to fetch schedules');
      } finally {
        this.isLoading = false;
      }
    },
    ...mapActions({
      fetchScheduleList: 'schedules/fetchScheduleList',
    }),
  },
};

</script>
